import mutations from './mutations'
import actions from './actions'

const state = {
  all_facilities: [],
  facilities: [],
  external_facility:[],
  facility: [],
  deleted_facilities: [],
  active_camping: [],
  active_facilities: [],
  available_facilities: [],
  available_external_facilities: [],
  inactive_facilities: [],
  active_accommodations: [],
  active_accommodation_campsite: [],
  recommended_camping: [],
  recommended_accommodation: [],
  facility_images: [],
  browser_facilities: [],
  chosenFacilities: [],
  chosenExternalFacility:[],

  bookedFacilities: [],
  bookedExternalFacilities:[],
  camping_multi_browser_facilities: [],
  multi_camping_arrivals: [],
  new_external_facility_data:[],
  confirmed_external_facility_data:[],
  facility_unavailability_schedule: [],
  surge_schedule: [],
  single_external_facilty_price: [],

  revenue_split_percent:[]
  
}

export default {
  state, mutations, actions
}
